import React from 'react';

import { Row, Col } from 'reactstrap';
import Accordion from '../../../components/Accordion';
import AccordionItem from '../../../components/Accordion/components/AccordionItem';

import AxisPosition from '../components/AxisPosition';
import BasePlate from '../components/BasePlate';
import BasePlateFactor from '../components/BasePlateFactor';
import { APP_TEXTS } from '../../../texts/texts';

const BracketAttachment = (props) =>  (
  <Row>
    <Col sm="12">
      <Accordion className="application__accordion" appStatus={props.appStatus}>
        <AccordionItem id="base_plate" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE.Content}>
          <BasePlate />
        </AccordionItem>
        <AccordionItem id="axis_position" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_AXIS_POSITION.Content}>
          <AxisPosition />
        </AccordionItem>
        <AccordionItem id="base_plate_factor" title={APP_TEXTS.BRACKET_ATTACHMENT_TITLE_BASE_PLATE_FACTOR.Content}>
          <BasePlateFactor />
        </AccordionItem>
      </Accordion>
    </Col>
  </Row>
);

export default BracketAttachment;



// WEBPACK FOOTER //
// ./src/views/Dimension/BracketAttachment/BracketAttachment.js